/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaAttributoValoreDTO } from '../model/paged-model-tipo-pratica-attributo-valore-dto';
// @ts-ignore
import { TipoPraticaAttributoValoreCreationForm } from '../model/tipo-pratica-attributo-valore-creation-form';
// @ts-ignore
import { TipoPraticaAttributoValoreDTO } from '../model/tipo-pratica-attributo-valore-dto';
// @ts-ignore
import { TipoPraticaAttributoValorePatchForm } from '../model/tipo-pratica-attributo-valore-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaAttributoValoriControllerServiceInterface,
    CreateTipoPraticaAttributoValoreRequestParams,
    DeleteTipoPraticaAttributoValoreRequestParams,
    GetTipoPraticaAttributoValoreRequestParams,
    ListTipoPraticaAttributoValoriRequestParams,
    UpdateTipoPraticaAttributoValoreRequestParams
} from './tipo-pratica-attributo-valori-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaAttributoValoriControllerService extends BaseService implements TipoPraticaAttributoValoriControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea una nuova opzione catalogata dell\&#39;attributo (CUSTOM_SINGLE_CHOICE / CUSTOM_MULTIPLE_CHOICE)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaAttributoValore(requestParameters: CreateTipoPraticaAttributoValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoValoreDTO>;
    public createTipoPraticaAttributoValore(requestParameters: CreateTipoPraticaAttributoValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoValoreDTO>>;
    public createTipoPraticaAttributoValore(requestParameters: CreateTipoPraticaAttributoValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoValoreDTO>>;
    public createTipoPraticaAttributoValore(requestParameters: CreateTipoPraticaAttributoValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaAttributoValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling createTipoPraticaAttributoValore.');
        }
        const tipoPraticaAttributoValoreCreationForm = requestParameters?.tipoPraticaAttributoValoreCreationForm;
        if (tipoPraticaAttributoValoreCreationForm === null || tipoPraticaAttributoValoreCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaAttributoValoreCreationForm was null or undefined when calling createTipoPraticaAttributoValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoValoreDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaAttributoValoreCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina una opzione dell\&#39;attributo
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaAttributoValore(requestParameters: DeleteTipoPraticaAttributoValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaAttributoValore(requestParameters: DeleteTipoPraticaAttributoValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaAttributoValore(requestParameters: DeleteTipoPraticaAttributoValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaAttributoValore(requestParameters: DeleteTipoPraticaAttributoValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaAttributoValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling deleteTipoPraticaAttributoValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling deleteTipoPraticaAttributoValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una opzione per id (path consistency: 404 se la chain e\&#39; rotta)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaAttributoValore(requestParameters: GetTipoPraticaAttributoValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoValoreDTO>;
    public getTipoPraticaAttributoValore(requestParameters: GetTipoPraticaAttributoValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoValoreDTO>>;
    public getTipoPraticaAttributoValore(requestParameters: GetTipoPraticaAttributoValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoValoreDTO>>;
    public getTipoPraticaAttributoValore(requestParameters: GetTipoPraticaAttributoValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaAttributoValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling getTipoPraticaAttributoValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling getTipoPraticaAttributoValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoValoreDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle opzioni dell\&#39;attributo (sort default: ordine, id ASC)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaAttributoValori(requestParameters: ListTipoPraticaAttributoValoriRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaAttributoValoreDTO>;
    public listTipoPraticaAttributoValori(requestParameters: ListTipoPraticaAttributoValoriRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaAttributoValoreDTO>>;
    public listTipoPraticaAttributoValori(requestParameters: ListTipoPraticaAttributoValoriRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaAttributoValoreDTO>>;
    public listTipoPraticaAttributoValori(requestParameters: ListTipoPraticaAttributoValoriRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaAttributoValori.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling listTipoPraticaAttributoValori.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaAttributoValori.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaAttributoValoreDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di una opzione (richiede version per optimistic lock; value frozen post-pubblicazione)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaAttributoValore(requestParameters: UpdateTipoPraticaAttributoValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoValoreDTO>;
    public updateTipoPraticaAttributoValore(requestParameters: UpdateTipoPraticaAttributoValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoValoreDTO>>;
    public updateTipoPraticaAttributoValore(requestParameters: UpdateTipoPraticaAttributoValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoValoreDTO>>;
    public updateTipoPraticaAttributoValore(requestParameters: UpdateTipoPraticaAttributoValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaAttributoValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling updateTipoPraticaAttributoValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling updateTipoPraticaAttributoValore.');
        }
        const tipoPraticaAttributoValorePatchForm = requestParameters?.tipoPraticaAttributoValorePatchForm;
        if (tipoPraticaAttributoValorePatchForm === null || tipoPraticaAttributoValorePatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaAttributoValorePatchForm was null or undefined when calling updateTipoPraticaAttributoValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoValoreDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaAttributoValorePatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
